import { render } from "./posts.vue?vue&type=template&id=5284add1&scoped=true"
import script from "./posts.vue?vue&type=script&lang=js"
export * from "./posts.vue?vue&type=script&lang=js"

import "./posts.vue?vue&type=style&index=0&id=5284add1&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\zoinix-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5284add1"]])

export default __exports__